import {Heading, Img, Button, Slider} from "./.."
import React, {useState} from "react";
import AliceCarousel, {EventObject} from "react-alice-carousel";
import {useTranslation} from "react-i18next";

export default function CaseSection() {
    const [sliderState, setSliderState] = React.useState(0);
    const sliderRef = React.useRef<AliceCarousel>(null);

    const {t} = useTranslation();

    const [showAll, setShowAll] = useState(false);


    const caseItems = [
        {
            problemTitle: "case.case_1.problem_title",
            problemDescription: "case.case_1.problem_description",
            whatBee: "case.case_1.what_bee",
            whatBeeSteps: "case.case_1.what_bee_steps",
            result: "case.case_1.result",
            resultSteps: "case.case_1.result_steps",
            image: "/images/caseImage.png"
        },
        {
            problemTitle: "case.case_2.problem_title",
            problemDescription: "case.case_2.problem_description",
            whatBee: "case.case_2.what_bee",
            whatBeeSteps: "case.case_2.what_bee_steps",
            result: "case.case_2.result",
            resultSteps: "case.case_2.result_steps",
            image: "/images/case_2.png"
        }
    ];

    const itemsToShow = showAll ? caseItems : caseItems.slice(0, 1);

    return (
        <>
        <section id="Case">
            <div className="flex flex-col gap-10 md:gap-[30px]">
                <div className="container-xs px-6">
                    <div className="flex items-start lg:justify-center">
                        <Heading
                            size="desktop_heading_4"
                            className="font-medium leading-[33.6px] text-[#191C30E5] uppercase my-3">
                            {t("case.head_title")}
                        </Heading>
                        <div className="flex flex-1 justify-end gap-4 self-end md:hidden sm:hidden">
                            <Button
                                onClick={() => sliderRef.current?.slidePrev()}
                                className="w-[56px] h-[56px] flex items-center justify-center rounded-[12px] bg-[#6C6C6C] hover:bg-[#0C88F0]"
                            >
                                <Img
                                    src="/images/left_arrow_white.svg"
                                    alt="Prev"
                                    className="h-[24px]"
                                />
                            </Button>
                            <Button
                                onClick={() => sliderRef.current?.slideNext()}
                                className="w-[56px] h-[56px] flex items-center justify-center rounded-[12px] bg-[#6C6C6C] hover:bg-[#0C88F0]"
                            >
                                <Img
                                    src="/images/right_arrow_white.svg"
                                    alt="Next"
                                    className="h-[24px]"
                                />
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="container-xs flex gap-5 overflow-hidden md:hidden sm:hidden">
                    <div className="flex w-full px-6">
                        <Slider
                            autoPlay
                            autoPlayInterval={5000000}
                            responsive={{
                                "0": { items: 1 },
                                "551": { items: 1 },
                                "1024": { items: 1 },
                                "1441": { items: 1 },
                            }}
                            disableDotsControls
                            activeIndex={sliderState}
                            onSlideChanged={(e: EventObject) => setSliderState(e.item)}
                            ref={sliderRef}
                            paddingRight={20}
                            items={caseItems.map((item, index) => (
                                <div key={index} className="flex gap-5 pr-5">
                                    <div className="flex w-[333px] h-auto flex-col gap-10 rounded-[48px] bg-[#008443]">
                                        <div className="mt-9 flex flex-col items-start gap-5 px-10">
                                            <Heading size="desktop_heading_6" className="font-medium leading-[120%] text-[#FFFFFF] uppercase">
                                                {t(item.problemTitle)}
                                            </Heading>
                                            <Heading size="desktop_body_l" className="font-medium text-[#FFFFFF] mt-5">
                                                {t(item.problemDescription)}
                                            </Heading>
                                        </div>
                                        <div className="flex flex-col items-center justify-center bg-[#333333] px-14 py-[134px] rounded-b-[48px] mt-2">
                                            <Img src="/images/feature_1.svg" />
                                        </div>
                                    </div>
                                    <div className="flex flex-1 gap-5 rounded-[48px] bg-[#ededed]">
                                        <div className="flex flex-1 flex-col gap-10 py-[40px]">
                                            <div className="flex flex-col items-start gap-3.5">
                                                <Heading size="desktop_heading_6" className="font-medium leading-[120%] text-[#191C30E5] uppercase ml-10">
                                                    {t(item.whatBee)}
                                                </Heading>
                                                <Heading size="desktop_body_l" className="font-medium text-[#191C30E5] self-end w-[94%] whitespace-pre-line">
                                                    {t(item.whatBeeSteps)}
                                                </Heading>
                                            </div>
                                            <div className="flex flex-col items-start gap-5">
                                                <Heading size="desktop_heading_6" className="font-medium leading-[120%] text-[#191C30E5] ml-10 uppercase whitespace-pre-line">
                                                    {t(item.result)}
                                                </Heading>
                                                <Heading size="desktop_body_l" className="font-medium text-[#191C30E5] ml-10 whitespace-pre-line">
                                                    {t(item.resultSteps)}
                                                </Heading>
                                            </div>
                                        </div>
                                        <Img src={item.image} className="h-auto w-[32%] rounded-tr-[48px] rounded-br-[48px] object-cover" />
                                    </div>
                                </div>
                            ))}
                        />
                    </div>
                </div>
                <div className="flex flex-col w-full px-5 gap-4 lg:hidden">
                    {itemsToShow.map((item, index) => (
                        <div key={index} className=" gap-5 grid sm:gap-2 md:gap-4">
                            <div className="flex h-[395px] sm:h-auto md:h-auto flex-col gap-10 rounded-[32px] bg-[#008443]">
                                <div className="mt-5 flex flex-col items-start gap-5 px-10 md:px-6 md:mt-6 md:gap-4 sm:px-6 sm:mt-6 sm:gap-4">
                                    <Heading size="desktop_heading_6" className="font-medium leading-[120%] text-[#FFFFFF] uppercase">
                                        {t(item.problemTitle)}
                                    </Heading>
                                    <Heading size="desktop_body_l" className="font-medium text-[#FFFFFF]">
                                        {t(item.problemDescription)}
                                    </Heading>
                                </div>
                                <div className="flex flex-col items-center justify-center bg-[#333333] px-14 py-[60px] sm:py-[42px] rounded-b-[32px]">
                                    <Img src="/images/feature_1.svg" />
                                </div>
                            </div>
                            <div className="grid gap-5 rounded-[48px] bg-[#ededed] md:rounded-[32px] sm:rounded-[32px]">
                                <div className="flex flex-1 flex-col gap-6 py-[40px] md:py-6 sm:py-6">
                                    <div className="flex flex-col items-start gap-4">
                                        <Heading size="desktop_heading_6" className="font-medium leading-[120%] text-[#191C30E5] uppercase mx-6 ">
                                            {t(item.whatBee)}
                                        </Heading>
                                        <Heading size="desktop_body_l" className="font-medium text-[#191C30E5] self-end mx-6 whitespace-pre-line">
                                            {t(item.whatBeeSteps)}
                                        </Heading>
                                    </div>
                                    <div className="flex flex-col items-start gap-4">
                                        <Heading size="desktop_heading_6" className="font-medium leading-[120%] text-[#191C30E5] mx-6 uppercase whitespace-pre-line">
                                            {t(item.result)}
                                        </Heading>
                                        <Heading size="desktop_body_l" className="font-medium text-[#191C30E5] ml-10 md:ml-6 sm:ml-6 whitespace-pre-line mx-6">
                                            {t(item.resultSteps)}
                                        </Heading>
                                    </div>
                                </div>
                                <Img src={item.image} className="h-[231px] w-full rounded-b-[48px] md:rounded-b-[32px] sm:rounded-b-[32px] object-cover" />
                            </div>
                        </div>
                    ))}

                    <Button
                        shape="round"
                        onClick={() => setShowAll(prev => !prev)}
                        rightIcon={
                            <Img
                                src={showAll ? "/images/img_icon24_up.svg" : "/images/img_icon24.svg"}
                                alt="Arrow Down"
                                className={`h - [24px] w-[24px] object-contain ${showAll ? "pt-0.5" : "pt-0"}`}
                            />
                        }
                        className="rounded-[12px] w-[220px] sm:w-full px-[34px] font-extrabold sm:px-4 text-center h-[56px] sm:h-[44px] text-[15px] bg-[#F4F4F4] hover:opacity-[92%] text-[#1b1f3b] self-center"
                    >
                        {showAll ? t("faq.close_button") : t("faq.expand_button")}
                    </Button>
                </div>
            </div>
        </section>
        </>
)
}